import classes from "../homePageNew.module.css";
import { StackIcon } from "./icons";
import ReportRow from "./ReportRow";

/**
 * REPORTING strip — latest monitoring report across ALL of the user's
 * brands (Tesla + Ford together), rendered with the same ReportRow every
 * other module uses so it shows the combination the report was launched
 * for (brand, category, market, persona, models). "N more reports" is the
 * total count minus the one shown, and opens MonitoringReportsModal listing
 * every report.
 */
export default function MonitoringReportingStrip({ reports, loading, onOpenReportsModal, onViewReport }) {
  const latest = reports?.[0];
  const moreCount = (reports?.length || 0) - 1;

  return (
    <div className={classes.monReportingStrip}>
      <div className={classes.monReportingTitle}>REPORTING</div>
      {latest ? (
        <>
          <ReportRow
            jobId={latest.jobId}
            status={latest.status}
            type={latest.type}
            brand={latest.brand}
            category={latest.category}
            market={latest.markets}
            persona={latest.persona}
            llms={latest.llms}
            date={latest.date}
            onView={(jobId) => onViewReport({ jobId, category: latest.category })}
          />
          {moreCount > 0 && (
            <button className={classes.moreReportsLink} onClick={onOpenReportsModal}>
              <StackIcon size={13} />
              {moreCount} more report{moreCount > 1 ? "s" : ""} for this run
            </button>
          )}
        </>
      ) : (
        <div className={classes.monReportRow}>
          <span className={classes.monReportMetaMuted}>{loading ? "Loading reports…" : "No monitoring report generated yet."}</span>
        </div>
      )}
    </div>
  );
}
